<div class="row" [ngClass]="{ 'summary': viewMode === 'summary' }">
  <div class="content">
    <ng-content select="[formContent]"/>
  </div>
  <div class="array-item-actions">
    <ng-content select="[arrayItemActions]"/>
  </div>
</div>

